var $3845890278fa1f1e$exports = {};
console.log("hellow worlds!");


//# sourceMappingURL=parcel.7ce35157.js.map
